<template>
  <!-- 二代机 -->
  <div class="indictment-page main-page">
    <Menus title="要素式起诉状答辩状" :home="true" />
    <div class="list-panel">
      <div class="item" @click="toLink('/indictment')">
        <img src="https://qiniu.laway.cn/publaw/4c28391a2ae911f0ac5dfa2800182ac7.png" alt="">
        <h2>智能生成</h2>
        <div class="intro">要素式起诉状/答辩状</div>
        <div class="desc">

          <div class="p1">系统帮助解读要素，显著降低填写难度</div>
          <div class="p2">根据引导填写案件信息，更具逻辑性</div>
          <div class="p3">自动计算赔偿数额</div>

        </div>
        <button>立即进入</button>
      </div>
      <div class="item shibie" @click="toLink('/easyclaim')">
        <img src="https://qiniu.laway.cn/publaw/1bdea5162aec11f0ac5dfa2800182ac7.png" alt="">
        <h2>识别生成</h2>
        <div class="intro">要素式起诉状/答辩状</div>
        <div class="desc">

          <div class="p1">上传传统起诉状/答辩状等材料，AI识别生成</div>
          <div class="p2">描述案情，AI生成起诉状/答辩状</div>
          <div class="p3">在线填写起诉状/答辩状，在线生成</div>

        </div>
        <button>立即进入</button>
      </div>

    </div>
  </div>
</template>

<script>
import Menus from '@/components/Menu'

export default {
  components: {
    Menus
  },
  methods: {
    toLink (ailink) {
      const { code, no } = this.$point
      const query = `?machineId=${no}&code=${code}&device_type=3`
      const link = `${this.appSite}/terminal` + ailink + query
      window.location.href = link
    }
  }
}
</script>

<style lang="stylus" scoped>
.indictment-page
  .list-panel
    display flex
    justify-content center
    padding-top 0.8rem
    .item
      width 7.72rem
      height 7.8rem
      margin 0 0.45rem
      background-color rgba(255, 255, 255, 0.2)
      border-radius 45px
      border solid 1px rgba(255, 255, 255, 0.2)
      text-align center
      padding-top 0.44rem
      color #fff
      img
        width 5.9rem
      h2
        font-size 0.38rem
        margin-top 0.4rem
        font-weight bold
      .intro
        font-size 0.28rem
        margin-bottom 0.5rem
      button
        width 6.72rem
        height 0.7rem
        background-color #407dff
        border-radius 0.1rem
        color #fff
        border 0
        margin-top 0.5rem
        font-size 0.28rem
      .desc
        position relative
        width 5.58rem
        border-left solid 2px rgba(255, 255, 255, 0.2)
        border-right solid 2px rgba(255, 255, 255, 0.2)
        margin 0 auto
        font-size 0.24rem
        display flex
        justify-content center
        flex-direction column
        align-items center
        line-height 1.6
        .p1
          margin-top -0.15rem
          &:after, &:before
            content ''
            position absolute
            width 0.56rem
            height 2px
            background rgba(255, 255, 255, 0.2)
            top 0
          &:before
            left 0
          &:after
            right 0
        .p3
          margin-bottom -0.15rem
          &:after, &:before
            content ''
            position absolute
            width 1.65rem
            height 2px
            background rgba(255, 255, 255, 0.2)
            bottom 0
          &:before
            left 0
          &:after
            right 0
      &.shibie
        .desc
          .p1
            &:after, &:before
              width 0.23rem
          .p3
            &:after, &:before
              width 0.6rem
.page-vertical
  .list-panel
    display block
    padding-top 0.4rem
    .item
      margin 0 auto 0.4rem
      max-width 90%
</style>
